module.exports = __webpack_public_path__ + "media/images/restaurant/logo_amex-e2898c560b4321e69e46e208b9bd91ca.png";